var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYoutube = function SvgIconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.54 14.42a2.78 2.78 0 0 0-1.94-2C26.88 12 20 12 20 12s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 9 19.75a28.999 28.999 0 0 0 .46 5.33A2.78 2.78 0 0 0 11.4 27c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2c.312-1.732.466-3.49.46-5.25a29.005 29.005 0 0 0-.46-5.33Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon_youtube_svg__triangle",
    d: "m17.75 23.02 5.75-3.27-5.75-3.27v6.54Z",
    fill: "#fff"
  })));
};
export default SvgIconYoutube;